<template>
  <div class="container">
    <div class="" style="padding-top:25px;padding-bottom:5px;background-color: #f1eded">
      <div class="section-banner" style=" height: 100px;">
        <van-row>
          <van-col span="6" style="text-align: right">
            <van-image round
                       :src="$getFileAccessHttpUrl(shopInfo.topPic)"
                       width="75px" height="75px">
            </van-image>
          </van-col>
          <van-col span="18">
            <div style="margin-left: 20px;margin-top: 5px;text-align: left;">
              <div style="font-size: 18pt">{{ shopInfo.name }}</div>
              <div v-if=" shopInfo.readCount"
                   style="font-size: 10pt;margin-top: 10px;color: gray; white-space:nowrap; overflow: hidden;text-overflow: ellipsis;">
                {{ shopInfo.readCount }}人次访问 | {{ shopInfo.tags }}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-notice-bar
        v-if="departNotice&&departNotice.name"
        @click="goNotice"
        left-icon="volume-o"
        :text="departNotice.name"
    />
    <van-tabs>
      <van-tab title="服务">
        <van-row>
          <van-col span="6">
            <van-sidebar v-model="activeKey" @change="onChangeActiveKey">
              <van-sidebar-item :title="item.name" v-for="item in pcList" :key="item.id"/>
            </van-sidebar>
          </van-col>
          <van-col span="18">
            <div>
              <van-empty v-if="list.length===0" description="暂无数据"/>
              <van-list
                  v-else
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了">
                <div style="border-radius: 10px;overflow: hidden;margin: 10px 0px" class="productList"
                     v-for="item in list"
                     :key="item.id">
                  <van-card
                      :tag="item.typeFlag===10?'三人团':(item.typeFlag===30?'群接龙':'')"
                      :thumb="$getFileAccessHttpUrl(item.listPic)" lazy-load @click="goOilInfo(item.id)"
                            :desc="item.remark">
                    <template slot="title">
                      <div style="font-size: 12pt;font-weight: 520;" class="line2">{{ item.name }}</div>
                    </template>
                    <template slot="price">
                      <span class="hongrenminbi">￥</span><span class="prices">{{ item.amount }}</span>
                    </template>
                  </van-card>
                </div>
              </van-list>
            </div>
          </van-col>
        </van-row>
      </van-tab>
      <van-tab title="商家信息">
        <div style="margin-top: 10px">
          <van-row>
            <van-col span="1">
              <van-icon name="location-o" size="16" style="margin-left: 5px;margin-top: 3px"/>
            </van-col>
            <van-col span="21">
              <div style="font-size: 12pt;margin-left: 10px" @click="goDaoHang">{{ shopInfo.address }}</div>
            </van-col>
            <van-col span="2">
              <van-icon @click="goDaoHang" name="arrow" size="16" style="margin-top: 3px"/>
            </van-col>
            <!--            <van-col span="3">-->
            <!--              <van-icon name="phone-o" size="30" color="#1989fa" @click="callMobile"/>-->
            <!--            </van-col>-->
          </van-row>
          <van-row style="margin-top: 10px">
            <van-col span="1">
              <van-icon name="phone-o" size="16" style="margin-left: 5px;margin-top: 3px"/>
            </van-col>
            <van-col span="21">
              <div style="font-size: 12pt;margin-left: 10px" @click="callMobile">{{ shopInfo.mobile }}</div>
            </van-col>
            <van-col span="2">
              <van-icon name="arrow" size="16" @click="callMobile" style="margin-top: 3px"/>
            </van-col>
          </van-row>
        </div>
        <van-row>
          <div class="content">
            商家介绍
            <div v-html="$imgCheck(shopInfo.remark)"></div>
            <br> <br> <br>
          </div>
        </van-row>
      </van-tab>
    </van-tabs>
    <Footer :active="0" :is-login="isLogin"></Footer>
  </div>
</template>

<script>
import {
  Cell,
  Tabs,
  Tab,
  NoticeBar,
  List,
  Button,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem,
  Card,
  Sidebar,
  SidebarItem
} from 'vant';
import Footer from '@/view/index/footer'
import {postAction} from '@/api/manage';
import wx from 'weixin-js-sdk'
import {Toast, Dialog} from 'vant'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import Vue from 'vue';

export default {
  components: {
    [Cell.name]: Cell, [Card.name]: Card, [NoticeBar.name]: NoticeBar,
    [Button.name]: Button, [DropdownItem.name]: DropdownItem, [Tabs.name]: Tabs, [Tab.name]: Tab,
    [Swipe.name]: Swipe, [DropdownMenu.name]: DropdownMenu, [Sidebar.name]: Sidebar, [SidebarItem.name]: SidebarItem,
    [SwipeItem.name]: SwipeItem, [List.name]: List, Footer,
  },
  data() {
    return {
      pcList: [],
      activeKey: 0,
      shopInfo: {},
      list: [],
      departNotice: {},
      mui: this.$route.query.mui,
      parentId: this.$route.query.parentId,
      loading: false,
      finished: true,
      pageNumber: 1,
      userGps: '',
      isLogin: false,
      shareTitle: '',
      shareRemark: '',
      shareImg: ''
    };
  },
  mounted() {
    this.checkLogin()
    this.getPicRollData();
    this.getShopNotice();
  },
  methods: {
    checkLogin() {
      var that = this;
      postAction('/web/api/user/checkLogin', {}).then(function (response) {
        console.log(response.result)
        that.isLogin = response.result.isLogin
      })
    },
    //跳转通知公告
    goNotice() {
      this.$router.push({name: 'noticeInfo', query: {id: this.departNotice.id}});
    },
    getShopNotice() {
      var that = this;
      postAction('/web/api/index/shopNotice', {mui: this.mui, parentId: this.parentId}).then(function (response) {
        console.log(response.result)
        that.departNotice = response.result.dn
      })
    },
    wxShare(that, userId) {
      // 微信分享配置
      wx.ready(function () {
        wx.updateTimelineShareData({
          title: that.shareTitle, // 分享标题
          link: 'http://mjj.meijiajing.top/main?mui=' + that.mui + '&parentId=' + userId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.$getFileAccessHttpUrl(that.shareImg), // 分享图标
          success: function () {
            // 设置成功
          }
        })
        wx.updateAppMessageShareData({
          title: that.shareTitle, // 分享标题
          link: 'http://mjj.meijiajing.top/main?mui=' + that.mui + '&parentId=' + userId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.$getFileAccessHttpUrl(that.shareImg), // 分享图标
          desc: that.shareRemark,  // 分享描述
          success: function () {
            // 设置成功
          }
        })
      })
    },
    //进入加油站详情
    goOilInfo(id) {

      if (this.isLogin) {
        this.$router.push({name: 'prodInfo', query: {id: id}});
      } else {
        Dialog.confirm({
          message: '您还没有登录，是否需要跳转登录？',
        }).then(() => {
          window.location.href = "/checkLogin?urls=" + encodeURI(window.location.href);
        }).catch(() => {
        });
      }
    },

    //重新加载数据
    listDataClear() {
      // 清空列表数据
      this.finished = false;
      this.pageNumber = 1
      this.list = []
      this.loadData()
    },
    //获取轮播图片
    getPicRollData() {
      Toast.loading({message: '加载中...'});
      const that = this;
      postAction('/web/api/index/shopInfo', {mui: this.mui}).then(function (response) {
        console.log(response.result)
        that.shopInfo = response.result.shopInfo
        if (that.shopInfo.address) {
          that.shopInfo.address = that.shopInfo.address.substring(that.shopInfo.address.indexOf('省') + 1);
        }
        Toast.clear()
        that.pcList = response.result.pcList
        that.shareTitle = response.result.shopInfo.name
        that.shareImg = response.result.shopInfo.topPic
        that.shareRemark = response.result.shopInfo.shareContent
        var pcLocal = localStorage.getItem("pcLocal");
        if (pcLocal && parseInt(pcLocal) < that.pcList.length) {
          that.activeKey = parseInt(pcLocal);
        }
        document.title=that.shopInfo.name
        that.wxShare(that, response.result.userId);
        that.loadData()
      })
    },
    goDaoHang() {
      window.location.href = "https://mapapi.qq.com/web/mapComponents/locationMarker/v/index.html?type=0&marker=coord%3A" + this.shopInfo.lat + "%2C" + this.shopInfo.lng + "%3Btitle%3A" + this.shopInfo.name + "&referer=myapp&key=WEFBZ-AIIWD-I2K4P-PB5I3-FWAZZ-2FFML";
    },
    callMobile() {
      window.location.href = 'tel:' + this.shopInfo.mobile
    },
    onChangeActiveKey(index) {
      this.listDataClear()
      localStorage.setItem("pcLocal", index);
    },
    loadData() {
      const that = this
      //发送 post 请求
      this.$nextTick(() => {
        postAction('/web/api/index/productList', {
          mui: this.mui,
          catalogId: this.pcList[this.activeKey].id
        }).then(function (response) {
          console.log(response.result)
          that.list = response.result.data
          // 加载状态结束
          that.loading = false
          // 数据全部加载完成
          that.finished = true
        })
      })
    },
  }
};
</script>

<style lang="less">
.van-cell__left-icon {
  margin-top: 5px;
}

.van-cell__right-icon {
  margin-top: 5px;
}

.content {
  margin: 10px;
}

.productList .van-card__header {
  margin-left: -7px;
}

.content img {
  max-width: 100%;
  display:block;float:left
}
</style>
